import { styled, ToggleButton } from "@mui/material";

export const TpToggleButton = styled(ToggleButton)(({ theme }) => ({
  height: '24px',
  paddingTop: 0,
  paddingBottom: 0,
  fontSize: '0.8125rem',
  textTransform: 'none',
  backgroundColor: theme.palette.background.paper,
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: 8,

  '&:hover': {
    backgroundColor: theme.palette.primary[400],
    color: theme.palette.primary.contrastText,
  },

  '&.Mui-selected:not(.Mui-disabled)': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.main,

    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  '&:disabled': {
    opacity: 0.5,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[400],
    color: theme.palette.primary.contrastText,
  },
}))
